import {
  useEffect,
  useState
} from 'react'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { ArrowIcon } from 'assets/icons'
import {
  Box,
  IconButton,
  Stack,
  Text
} from '@chakra-ui/react'
import { LoadingSpinier } from 'common/Loading'
import {
  isAuth,
  isNotMobile,
  showCoordParams
} from 'utils/helpers'
import {
  MODAL_SECTION,
  PENDING,
  SUCCEEDED
} from 'utils/constants'
import {
  authSelectors,
  getEventData,
  handleOpenModal,
  markersSelectors,
  setCloseChatModal,
  setEventCommentTree,
  setEventData,
  setHideChat,
  setHideNotification,
  setOpenPopupEvents,
  setSelectedEventData,
  showCurrentChatFriendMarkerCoordinate,
  usersSelectors,
  setUserSectionPage,
  setChatSectionPage,
  setOpenPopupBlogs,
  setNotificationSectionPage,
  setBlogRepostData
} from 'store'
import { AnimatePresence } from 'framer-motion'
import { COLORS } from 'utils/styles'

import { AskToSignUpModal } from 'components/Content/AskToSignUpModal'
import { Content } from 'components/Content/Map/Markers/EventMarkerPopup/Content'
import { StyledMotionBox } from './styled'

export const EventModal = () => {
  const dispatch = useDispatch()
  const { signInStatus } = useSelector(authSelectors)
  const {
    closeAllDrawers,
    eventCommentTree,
    getEventDataStatus,
    getUserProfileStatus,
    getUserStatus,
    openPopupEvents,
    chatSectionPage
  } = useSelector(usersSelectors)
  const { eventData } = useSelector(markersSelectors)

  const [hoveringChevron, setHoveringChevron] = useState(false)
  const [askToSignUp, setAskToSignUp] = useState(false)
  const [searchParams, setSearchParams] = useSearchParams()
  const [showComments, setShowComments] = useState(false)

  const isLoggedIn = signInStatus === SUCCEEDED || isAuth()
  const getDrawerHeight = (window.innerHeight - 120) + 'px'

  const handleAuthOverlayClick = () => {
    document.querySelector('#custom-popup-overlay')?.click()
    document.querySelector('#custom-popup-overlay-event')?.click()
    dispatch(setChatSectionPage('clear'))
    dispatch(setUserSectionPage('clear'))
    dispatch(setOpenPopupBlogs(false))
    dispatch(setOpenPopupEvents(false))
    dispatch(setNotificationSectionPage('clear'))
    dispatch(setBlogRepostData([]))
    dispatch(handleOpenModal({
      isOpen: false,
      section: MODAL_SECTION.RightSection
    }))
  }

  const closeDrawer = () => {
    setSearchParams({})
    setAskToSignUp(false)

    if (
      isLoggedIn
      && getUserProfileStatus === SUCCEEDED
      && !sessionStorage.getItem('eventid')
    ) {
      dispatch(setHideNotification(false))
      dispatch(setHideChat(false))
      dispatch(handleOpenModal({
        isOpen: true,
        section: MODAL_SECTION.RightSection
      }))
    }

    dispatch(setUserSectionPage('clear'))
    dispatch(setOpenPopupEvents(false))
    sessionStorage.removeItem('eventid')

    setTimeout(() => {
      dispatch(setEventData(null))
      dispatch(setSelectedEventData(null))
    }, 800)
  }

  const chevronDirection = (type) => {
    if (isNotMobile() && type === 'icon') {
      return showComments ? 'rotate(180deg)' : 'rotate(-90deg)'
    }

    if (isNotMobile() && type === 'text') {
      return showComments ? 'rotate(-180deg)' : 'rotate(90deg)'
    }

    return 'rotate(180deg)'
  }

  const GoToMarker = (item) => {
    document.querySelector('#event-modal-back-button')?.click()

    closeDrawer()
    dispatch(setCloseChatModal(true))
    setTimeout(() => dispatch(setCloseChatModal(false)), 300)
    document.querySelector('#event-modal-overlay')?.click()

    setTimeout(() => {
      let coord = {
        coord: item?.coordinates,
        isStatic: true
      }
      dispatch(showCurrentChatFriendMarkerCoordinate(coord))

      sessionStorage.setItem('openProfileAfterAnimation', item?.profile_id)
    }, 850)
  }

  const animateVariants = {
    WideScreen: {
      initial: {
        height: '0px',
        paddingBottom: '20px'
      },
      animate: {
        height: getDrawerHeight,
        paddingBottom: '0px'
      },
      exit: { height: '0px' }
    },
    NarrowScreen: {
      initial: {
        width: '95%',
        height: getDrawerHeight,
        marginRight: '10px',
        x: 450
      },
      animate: { x: 0 },
      exit: {
        x: 450,
        marginRight: '-450px'
      }
    }
  }

  useEffect(() => {
    if (
      isLoggedIn
      && getUserStatus === SUCCEEDED
      && sessionStorage.getItem('eventid')
      && askToSignUp
    ) {
      setAskToSignUp(false)
      dispatch(getEventData.pending())
    } else if (
      signInStatus === SUCCEEDED
      && getUserProfileStatus === SUCCEEDED
      && sessionStorage.getItem('eventid')
    ) {
      dispatch(getEventData(eventData?.id))

      if (eventData?.id) {
        setSearchParams({ eventid: eventData?.id })
      } else {
        showCoordParams(setSearchParams)
      }
    }
  }, [isLoggedIn, getUserProfileStatus, getUserStatus])

  useEffect(() => {
    if (closeAllDrawers) {
      closeDrawer()
    }
  }, [closeAllDrawers])

  useEffect(() => {
    if (!openPopupEvents && !chatSectionPage?.length) {
      setSearchParams({})
      showCoordParams(setSearchParams)
      sessionStorage.removeItem('eventid')
    }
  }, [openPopupEvents])

  return (
    <>
      <AskToSignUpModal
        dynamicOpenModal={!isLoggedIn && askToSignUp && openPopupEvents}
        eventData={eventData}
        type="events"
        setAskToSignUp={setAskToSignUp}
      />

      {
        !isLoggedIn
        && !askToSignUp
        && openPopupEvents
        && (
          <Stack
            id="event-modal-overlay"
            position="fixed"
            background="transparent"
            top="0"
            left="0"
            width="100%"
            height="100%"
            zIndex={1408}
            cursor="pointer"
            onClick={() => {
              if (!isLoggedIn && !askToSignUp) {
                setAskToSignUp(true)
              }
            }}
          />
        )
      }

      <AnimatePresence>
        {
          openPopupEvents
          && (
            <>
              <Box
                id="event-modal-overlay"
                zIndex={isAuth() ? 1399 : 1390}
                background="transparent"
                position="fixed"
                width="100%"
                height="50px"
                top={0}
                onClick={() => {
                  if (isLoggedIn) {
                    handleAuthOverlayClick()
                  }
                }}
              />

              <Box
                zIndex={isAuth() ? 1399 : 1390}
                background="transparent"
                position="fixed"
                width="100%"
                height="50px"
                bottom={0}
                onClick={() => {
                  if (isLoggedIn) {
                    handleAuthOverlayClick()
                  }
                }}
              />

              <StyledMotionBox
                id="event-popup"
                variants={animateVariants[isNotMobile() ? 'WideScreen' : 'NarrowScreen']}
                initial="initial"
                animate="animate"
                exit="exit"
                transition={{
                  type: 'tween',
                  duration: 0.8
                }}
                {...(isNotMobile() ? {} : { maxWidth: '450px' })}
                onClick={() => {
                  if (!isLoggedIn && !askToSignUp) {
                    setAskToSignUp(true)
                  }
                }}
                cursor={isLoggedIn && !askToSignUp ? 'auto' : 'pointer'}
                style={{
                  translateX: '-50%',
                  transformOrigin: 'bottom center'
                }}
              >
                <Stack
                  alignItems="center"
                  justifyContent="center"
                  direction="row"
                  p="0px 5px"
                  background={COLORS.goldGradientRightToLeft}
                  minHeight="48px"
                  borderRadius="10px 10px 0 0"
                  marginTop="-1px"
                  position="sticky"
                  top="-0.2"
                  marginBottom="-7px"
                  zIndex={1000}
                  onClick={() => {
                    if (!isLoggedIn && !askToSignUp) {
                      setAskToSignUp(true)
                    }
                  }}
                >
                  <Text
                    maxWidth="70%"
                    fontSize="24px"
                    textAlign="center"
                  >
                    Event
                  </Text>

                  <IconButton
                    id="event-modal-back-button"
                    outline="none"
                    boxShadow="none"
                    position="absolute"
                    right="1.5"
                    background="unset"
                    transform={chevronDirection('icon')}
                    transition="none"
                    css={{
                      ':focus': {
                        outline: 'none',
                        boxShadow: 'none'
                      }
                    }}
                    icon={(
                      <>
                        <Text
                          fontWeight="300"
                          transform={chevronDirection('text')}
                          display={hoveringChevron ? 'flex' : 'none'}
                        >
                          {showComments ? 'Back' : 'Exit'}
                        </Text>

                        <Stack display={hoveringChevron ? 'none' : 'flex'}>
                          <ArrowIcon height="15px" />
                        </Stack>
                      </>
                    )}
                    _hover={{ background: COLORS.gold_hover }}
                    onClick={() => {
                      if (
                        isLoggedIn
                        && !askToSignUp
                      ) {
                        if (eventCommentTree.length) {
                          dispatch(setEventCommentTree(eventCommentTree.slice(0, -1)))
                          document.querySelector('#top-anchor').scrollIntoView({
                            behavior: 'instant',
                            block: 'start'
                          })
                        } else {
                          closeDrawer()
                          setHoveringChevron(false)
                        }
                      }
                    }}
                    onPointerEnter={(e) => {
                      if (e.pointerType === 'mouse') {
                        setHoveringChevron(true)
                      }
                    }}
                    onPointerLeave={(e) => {
                      if (e.pointerType === 'mouse') {
                        setHoveringChevron(false)
                      }
                    }}
                  />
                </Stack>

                <Stack
                  id="force-close-event-panel"
                  display="none"
                  onClick={() => closeDrawer()}
                />

                {
                  getEventDataStatus === PENDING
                    ? (
                      <Stack
                        width="100%"
                        marginTop="90px"
                        pointerEvents={isLoggedIn && !askToSignUp ? 'auto' : 'none'}
                      >
                        <LoadingSpinier />
                      </Stack>
                    ) : (
                      <Box
                        display="flex"
                        position="relative"
                        width="100%"
                        height="100%"
                        pointerEvents={isLoggedIn && !askToSignUp ? 'auto' : 'none'}
                      >
                        <Content
                          GoToMarker={GoToMarker}
                          setShowComments={setShowComments}
                          showComments={showComments}
                        />
                      </Box>
                    )
                }
              </StyledMotionBox>
            </>
          )
        }
      </AnimatePresence>
    </>
  )
}
